import { render, staticRenderFns } from "./bargainList.vue?vue&type=template&id=4a045d75&scoped=true&"
import script from "./bargainList.vue?vue&type=script&lang=js&"
export * from "./bargainList.vue?vue&type=script&lang=js&"
import style0 from "./bargainList.vue?vue&type=style&index=0&id=4a045d75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a045d75",
  null
  
)

export default component.exports